import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-plz',
    templateUrl: './input-field.component.html'
} )
export class PostcodeComponent extends AbstractFieldComponent<string> {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.postcode' );
    }

    set value( t: string | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.postcode = t;
        }
    }

    get value(): string | undefined {
        return this.jobapplication?.postcode;
    }
}
